<app-header>
  <div class="card p-5">
    <div class="card-body" class="text-center">
      <h2 class="title text-danger">Invalid OTP</h2>
      <p class="body-text mt-4">
        This OTP is invalid. Either the OTP entered is incorrect, or this OTP has already been used.<br>
        Please try again or reset the OTP for this feed.
      </p>
      <a class="btn btn-primary btn-xl" [routerLink]="['/activate']">Back</a>
    </div>
  </div>
</app-header>